import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AD_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AD_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 0h16v24H8V0z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h8v24H0V0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 0h8v24h-8V0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.3 19.423c.22-.063.41-.446.41-.446s.144.113.373.228c.229.114.466-.228.466-.228s.326 0 .468-.383c.143-.384-.284-.548-.284-.548s.499-.524 1.341-.524c.843 0 1.499 0 2.049-.234.55-.233 1.084-.634 1.284-1.468.2-.833-.433-1.358-.433-1.358s.14.044.433-.195c.292-.24-.18-1.01-.433-1.01-.254 0-.284.143-.284.143s-.157-.136-.372-.599c-.214-.462.215-.868.215-.868s.236.135.44-.088c.206-.222-.106-.563-.106-.563s.988-.336.845-1.6c-.142-1.264-1.445-1.193-1.445-1.193s.04-.21-.144-.33c-.184-.12-.32.12-.32.12-.144-.333.278-.79.616-1.154.105-.113.202-.218.271-.307.292-.377.109-.843-.96-1.352-1.068-.509-1.651.175-1.737.417-.086.243.246.393.246.393-.27.237-.794.327-1.15.163-.356-.163-.198-.662-.125-.798l.032-.054c.1-.169.31-.523.093-.867-.244-.387-.668-.387-1.006-.168-.29.188-.7.288-.813.313-.114-.025-.525-.125-.814-.313-.338-.22-.761-.22-1.006.168-.218.344-.007.698.094.867l.03.054c.074.136.232.635-.124.798-.356.164-.88.074-1.15-.163 0 0 .332-.15.246-.393-.086-.242-.669-.926-1.737-.417-1.069.509-1.252.975-.96 1.352.07.09.166.194.27.307.339.365.761.82.617 1.154 0 0-.136-.24-.32-.12-.183.12-.144.33-.144.33S9.97 8.418 9.827 9.682c-.143 1.264.845 1.6.845 1.6s-.312.34-.107.563c.206.223.44.088.44.088s.43.406.215.868c-.214.463-.37.599-.37.599s-.031-.143-.285-.143c-.253 0-.725.77-.433 1.01.293.24.433.195.433.195s-.632.525-.433 1.358c.2.834.735 1.235 1.284 1.468.55.233 1.206.233 2.049.233.842 0 1.341.525 1.341.525s-.426.164-.284.548c.143.383.467.383.467.383s.238.342.467.228c.23-.115.373-.228.373-.228s.19.383.41.446v.009a.2.2 0 00.03-.002.2.2 0 00.03.002v-.009z",
      fill: "#BF9937"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.111 15.997l.105-.254c1.208.518 2.583.777 4.124.777 1.541 0 2.879-.259 4.013-.776l.11.252c-1.17.534-2.545.8-4.123.8-1.576 0-2.986-.266-4.229-.799z",
      fill: "#805440"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.479 7.232H20.018v7.03s-.001.62-.657.892c-.656.271-1.427.174-1.427.174s-.739-.159-1.129 0c-.239.098-.412.146-.51.168v.019l-.047-.008a.81.81 0 01-.047.008v-.019a3.426 3.426 0 01-.51-.168c-.39-.159-1.129 0-1.129 0s-.771.097-1.427-.174-.657-.892-.657-.892v-7.03z",
      fill: "#BF9937"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AD_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 7,
      width: 9,
      height: 9
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.479 7.232H20.018v7.03s-.001.62-.657.892c-.656.271-1.427.174-1.427.174s-.739-.159-1.129 0c-.239.098-.412.146-.51.168v.019l-.047-.008a.81.81 0 01-.047.008v-.019a3.426 3.426 0 01-.51-.168c-.39-.159-1.129 0-1.129 0s-.771.097-1.427-.174-.657-.892-.657-.892v-7.03z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AD_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#D00F3A", d: "M12.373 7.145h3.656v3.9h-3.656z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.436 7.145h3.791v3.9h-3.791v-3.9zM16.436 11.477h3.656v4.045h-3.656v-4.045z",
      fill: "#FEDF00"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#FEDF00", d: "M12.373 11.477h3.656v4.044h-3.656z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.143 13.299s.17-.173.17-.58.143-.676-.17-.676h-1.038c-.299 0-.145.18-.446 0-.301-.181-.544-.123-.544 0s.304.069.304.32c0 .25.115.032.115.484 0 .452.064.376.094.376s.03-.082.03-.2c0-.12-.014-.598.07-.451.083.147.124.078.165.245.041.167.152.33.076.406-.076.075-.23.14-.115.14s.282-.192.199-.516c-.084-.324.103-.03.103-.03s.442.098.47-.037c.03-.134.07.13.19.13s-.116.27-.215.313c-.099.042 0 .075 0 .075s.092.076.153 0c.062-.075.28-.323.28-.451s.14-.051.14.062c0 .113-.13.52-.08.455l.05-.066zM19.143 14.887s.17-.172.17-.579.143-.676-.17-.676h-1.038c-.299 0-.145.18-.446 0-.301-.181-.544-.124-.544 0 0 .123.304.069.304.32 0 .25.115.032.115.484 0 .451.064.376.094.376s.03-.082.03-.2c0-.12-.014-.598.07-.451.083.147.124.077.165.245.041.167.152.33.076.405-.076.076-.23.142-.115.142s.282-.193.199-.517c-.084-.324.103-.03.103-.03s.442.098.47-.037c.03-.134.07.129.19.129s-.116.271-.215.314c-.099.042 0 .075 0 .075s.092.076.153 0c.062-.075.28-.324.28-.451 0-.128.14-.051.14.062 0 .113-.13.52-.08.455l.05-.066z",
      fill: "#D00F3A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.21 10.297c0 .165-.084.291-.275.484l-.026.026-.05.051c-.028.028-.05.05-.068.072-.164.184-.45.025-.523-.154a4.64 4.64 0 00-.162-.293l-.005-.009-.056-.095-.05-.086a5.71 5.71 0 01-.065-.114c-.007-.012-.045.002-.111.087-.025.032.027.143.192.32l-.094.104c-.23-.225-.34-.37-.34-.47 0-.168.134-.259.386-.259.158 0 .243.112.37.392l.032.072c.062.139.102.214.15.276.059.073.093.07.153-.006.059-.074.113-.19.195-.398l.022-.056c.018-.043.026-.063.02-.067-.004-.003-.017.004-.041.017l-.03.017-.064.033-.574-1.38 1.087-1.319v2.748l-.07-.063a.764.764 0 00-.003.07zm.078-.003l-.005.005v-.009l.005.004zm.005-.004v.009l-.005-.005.005-.004zm0-2.748l1.087 1.32-.574 1.379-.063-.033c-.045-.023-.067-.039-.073-.034-.006.006.01.04.043.123.082.208.136.324.195.398.06.075.094.079.152.006.049-.062.089-.137.151-.276l.033-.072c.127-.28.211-.392.37-.392.25 0 .386.09.386.258 0 .101-.111.246-.341.47l-.094-.104c.165-.177.217-.287.192-.32-.066-.084-.104-.098-.11-.086a5.71 5.71 0 01-.066.114l-.05.086-.055.095-.006.01c-.093.16-.15.263-.162.292-.073.18-.36.338-.523.154a1.836 1.836 0 00-.067-.072l-.052-.051-.025-.026c-.191-.193-.275-.319-.275-.484a.8.8 0 00-.003-.07l-.07.063V7.542zm0 0l-.005-.006.005-.006v.012zm-.005-.006l-.005.006V7.53l.005.006zm-.067 2.647l.002-.003-.002.003z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.28 10.05V7.823l.94 1.065-.483 1.162c-.178-.062-.24.07-.149.304.055.14.098.24.14.317-.16-.162-.227-.264-.227-.373a.419.419 0 00-.03-.19c-.01-.018-.094-.036-.148-.048l-.044-.01zm-.441 0l-.484-1.162.919-1.057v2.227l-.041.009c-.048.01-.119.023-.129.041a.42.42 0 00-.03.19c0 .109-.066.21-.226.373.042-.078.085-.178.14-.318.092-.234.03-.365-.149-.303z",
      fill: "#FEDF00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.185 11.477h-.406v4.045h.406v-4.045zm.813 0h-.406v4.045h.406v-4.045zm.406 0h.406v4.045h-.406v-4.045zm1.219 0h-.406v4.045h.406v-4.045zM17.383 7.145h-.406v4.044h.406V7.145zm.812 0h-.406v4.044h.406V7.145zm.407 0h.406v4.044h-.406V7.145zm1.218 0h-.406v4.044h.406V7.145z",
      fill: "#D00F3A"
    }
  )))
);
export {
  c as default
};
